module.exports = __webpack_public_path__ + "static/leopard4-c936db8b5b0852b658a79f084127db3d.png";